var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button account__payments__submit",attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('span',{staticClass:"button__loader"}):(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }